export const youtubeRule =
  /^https:\/\/(?:www\.){0,1}(youtu.be\/([\w_-]+)|youtube.com(?:\/watch\?.*(?:v=([\w_-]+))|\/live\/([\w_-]+)))/;

export const youtubeShorts =
  /^https?:\/\/(?:www\.)?youtube\.com\/shorts\/([a-zA-Z0-9_-]+)/;

export const youtubePlaylist =
  /^https:\/\/(?:www\.){0,1}(youtu.be\/([\w_-]+)|youtube.com(?:\/playlist))/;

export const youtubeMusicRule =
  /^https:\/\/music.youtube.com(?:\/watch\?.*(?:v=([\w_-]+)))/;

export const instagramRule =
  /^https:\/\/(?:www\.){0,1}(?:instagram.com\/p\/([a-zA-Z0-9_-]+))/;

export const twitterRule =
  /^https:\/\/(?:www\.){0,1}(?:twitter.com\/(?:[a-zA-Z0-9_.-]+)\/status\/\d+)/;

export const xRule =
  /^https:\/\/(?:www\.){0,1}(?:x.com\/(?:[a-zA-Z0-9_.-]+)\/status\/\d+)/;

export const tiktokRule =
  /^https:\/\/(?:www\.){0,1}(?:tiktok.com\/(?:@[a-zA-Z0-9_.-]+)\/video\/\d+)/;

export const soundcloudRule =
  /^https:\/\/(?:www\.){0,1}(?:soundcloud.com\/(?:[a-zA-Z0-9_.-]+)\/(?:[a-zA-Z0-9_.-]+))/;

export const spotifyRule =
  /^https:\/\/(?:open.spotify.com\/(artist|track|album|playlist|show|episode)\/([a-zA-Z0-9_.-]+))/;

export const klipIdRule =
  /^https:\/\/(?:www\.){0,1}(?:klip.id\/([a-zA-Z0-9_-]+))/;

export const canvaRule =
  /^https:\/\/(?:www\.){0,1}(?:canva.com\/design\/((?:[a-zA-Z0-9_-]+)\/(?:[a-zA-Z0-9_-]+)))/;

export const gdocsRule =
  /^https:\/\/(?:www\.){0,1}(?:docs.google.com\/(spreadsheets|document|presentation)\/d\/e\/([a-zA-Z0-9_-]+))\/pub/;
